// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__3kl1Z","header":"ClearentDisclaimer_header__pazIL","inner":"ClearentDisclaimer_inner__3umpj"};